import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { navPath } from '../constant';

const Loading: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [countdown, setCountdown] = useState<number>(5);
  const [progress, setProgress] = useState<number>(100);

  useEffect(() => {
    let isMounted = true;

    const validateToken = async () => {
      try {
        const uri = '/api/v1/user/validate-token';
        const { data } = await axios.get<{ tokenValid: boolean }>(uri);

        if (!isMounted) return;

        if (data.tokenValid) {
          navigate(navPath.dashboard.index);
        } else {
          setError('Session expired. Please login again.');

          let timer = 5;
          const countdownInterval = setInterval(() => {
            if (!isMounted) {
              clearInterval(countdownInterval);
              return;
            }

            timer -= 1;
            setCountdown(timer);
            setProgress((timer / 5) * 100);

            if (timer <= 0) {
              clearInterval(countdownInterval);
              navigate(navPath.login);
            }
          }, 1000);
        }
      } catch (error: any) {
        if (!isMounted) return;

        setError('Session expired. Please login again.');

        let timer = 5;
        const countdownInterval = setInterval(() => {
          if (!isMounted) {
            clearInterval(countdownInterval);
            return;
          }

          timer -= 1;
          setCountdown(timer);
          setProgress((timer / 5) * 100);

          if (timer <= 0) {
            clearInterval(countdownInterval);
            navigate(navPath.login);
          }
        }, 1000);
      }
    };

    validateToken();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  const handleLoginClick = () => {
    navigate(navPath.login);
  };

  return (
    <>
      <Helmet>
        <title>Loading - Shell Monitor</title>
      </Helmet>
      <div className='min-h-screen flex flex-col justify-center items-center bg-gray-50 dark:bg-gray-800 p-4'>
        {!error ? (
          <div className='text-center'>
            <Loader2 className='h-16 w-16 animate-spin text-primary mx-auto' />
            <p className='mt-4 text-lg font-medium text-gray-700 dark:text-gray-300'>Loading...</p>
          </div>
        ) : (
          <Card className='w-full max-w-md shadow-lg'>
            <CardHeader>
              <CardTitle className='text-center'>Session Expired</CardTitle>
              <CardDescription className='text-center text-red-500'>{error}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className='space-y-4'>
                <div className='text-center text-sm text-muted-foreground'>Redirecting to login in {countdown} seconds...</div>
                <Progress value={progress} className='h-2' />
              </div>
            </CardContent>
            <CardFooter className='flex justify-center'>
              <Button onClick={handleLoginClick}>Login Now</Button>
            </CardFooter>
          </Card>
        )}
      </div>
    </>
  );
};

export default Loading;
